import { NotificationService } from './../../../services/notification.service';

import { TypedEvent } from './../../../common/typed-event';
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { EsoService, MappedSourcingDto, Product, ProductsContainerDto, ProductsGroupDto, Sourcing, SourcingDto, SourcingGraphNode } from "../eso.service";
import { ActivatedRoute } from "@angular/router";
import { Selection, SelectionData, SettingsService } from "../../settings/settings.service";
import { Location } from "@angular/common";
import { UtilsService } from 'src/app/services/utils.service';
import { CoreService } from 'src/app/services/core.service';
import { ComponentRouteData, NavigationService, ROUTE_METADATA } from 'src/app/core/navigation/services/navigation.service';
import { SelectionSetId } from 'src/app/enums/selection-set-id.enum';
import { DxTreeListComponent } from 'devextreme-angular';
import { CounterGroups } from 'src/app/services/loading-indication.service';

@Component({
	selector: "app-network-deep-dive",
	templateUrl: "./network-deep-dive.component.html",
	styleUrls: ["./network-deep-dive.component.scss"],
	standalone: false
})
export class NetworkDeepDiveComponent implements OnInit {

	//Auto Complete Variables
	public productsAutocompleteDataSource: string[] = [];

	public allProducts: Product[] = [];

	public selectedProduct: Product;
	public autocompleteCode: string;

	public topRows: number | null = null;

	public orderByColumnName: string = 'ProductId';
	public orderByColumnNameItems: Selection[];

	public orderByDirection: 'ASC' | 'DESC' = 'DESC';
	public sourcingData: ProductsContainerDto;

	public sourcingTreeListColumns: { columnName: string; caption: string }[] = [];

	public sourcingTreeListData: SourcingGraphNode[] = [];

	public sourcingTreeListText: string;

	public onSourcingTreeListTextChange(event: any) {

		this.sourcingTreeListText = event.trim();
	}

	// Captions for tooltip. Child component uses this.
	public captionsMapping: Map<string, string> = new Map<string, string>();

	public compactMode = false;

	public reload: boolean;

	private _reload() {
		setTimeout(() => this.reload = false);
		setTimeout(
			() => {
				this.reload = true;

			}
		);
	}

	@ViewChild("productsContainer", { static: false })
	public productsContainer: ElementRef;

	@ViewChild("selectedProductContainer", { static: false })
	public selectedProductContainer: ElementRef;

	public levelsDropdownOptions: string[] = ["All", "0", "1", "2", "3"];

	public static readonly INPUT_LEVELS_DROPDOWN_TEXT_PREFIX = "Upstream:";
	public inputLevelsDropdownSelectedItemValue: string = this.levelsDropdownOptions[2];
	public inputLevelsDropdownSelectedItem: string = `${NetworkDeepDiveComponent.INPUT_LEVELS_DROPDOWN_TEXT_PREFIX} ${this.inputLevelsDropdownSelectedItemValue}`;

	public static readonly OUTPUT_LEVELS_DROPDOWN_TEXT_PREFIX = "Downstream:";
	public outputLevelsDropdownSelectedItemValue: string = this.levelsDropdownOptions[2];
	public outputLevelsDropdownSelectedItem: string = `${NetworkDeepDiveComponent.OUTPUT_LEVELS_DROPDOWN_TEXT_PREFIX} ${this.outputLevelsDropdownSelectedItemValue}`;

	public onBackdropClicked: TypedEvent<any> = new TypedEvent<any>();

	public decimalPipeExpression: string = '0.0-2';

	private readonly _productIdQueryParamName = "id";

	constructor(
		private _esoService: EsoService,
		private _route: ActivatedRoute,
		private _settingsService: SettingsService,
		private _location: Location,
		private _navigationService: NavigationService,
	) { }

	public autocompleteInitialized: boolean;

	ngOnInit() {
		this._settingsService.getCoreSetting(
			null,
			"NetworkDeepDiveNumberOfDecimalPlaces",
			true,
			{
				showLoadingIndicator: false,
			}
		).then(
			(response) => {

				if (response) {
					this.decimalPipeExpression = `0.0-${response.value}`;
				}
			}
		);

		this.initializeAutocompleteData();

		// Captions for tooltip. Child component uses this.
		this._esoService.getEsoNetworkDeepDiveCaptions(
			{
				showLoadingIndicator: false,
			}
		).subscribe(
			(response) => {
				for (let i = 0; i < response.length; i++) {
					this.captionsMapping.set(response[i].selectionName, response[i].displayName);
				}
			}
		);

		this._settingsService.getSelections(
			SelectionSetId.EsoNetworkDeepDiveOrderByColumnNameItems,
			{
				showLoadingIndicator: false
			}
		).subscribe(
			{
				next: (selectionData: SelectionData) => {
					this.orderByColumnNameItems = selectionData.selections.map(
						(selection: Selection) => {
							if (!selection.caption) {
								selection.caption = `${selection.selectionName}`;// [Caption Missing]`;
							}

							return selection;
						}
					);
				}
			}
		);
	}

	public initializeAutocompleteList() {

		let source = this.allProducts.map((product) => product.code);

		this.productsAutocompleteDataSource = source;

		// debugger

		this.autocompleteInitialized = true;
	}

	private initializeAutocompleteData() {
		const $this = this;

		$this._route.queryParamMap.subscribe(
			(queryParams) => {
				let productId = queryParams.get($this._productIdQueryParamName);

				if (productId) {

					$this.selectProduct(productId);
				}

				this._esoService.getSourcingAutocompleteData(
					{
						showLoadingIndicator: false,
					}
				).subscribe(
					{
						next: (response) => {

							$this.allProducts = [];

							for (let a = 0; a < response.length; a++) {
								$this.allProducts.push(Object.assign(new Product(), { code: response[a] }));
							}

							$this.initializeAutocompleteList();

							if (!productId) {
								productId = this.allProducts[0].code;

								$this.selectProduct(productId);
							}
						}
					}
				);
			}
		);
	}

	private populateProductsGroupRecursively(
		data: SourcingGraphNode[],
		productsGroup: ProductsGroupDto,
		parentEsoObjectId: number,
		level: number,
		increment: number
	): ProductsGroupDto {

		const levelsData: SourcingGraphNode[] = data.filter(
			(sourcingGraphNode) => sourcingGraphNode.level === level && sourcingGraphNode.parentEsoObjectId === parentEsoObjectId
		);

		productsGroup.productsGroups = [];

		for (let a = 0; a < levelsData.length; a++) {
			const levelData: SourcingGraphNode = levelsData[a];
			const levelProductsGroup: ProductsGroupDto = new ProductsGroupDto();

			levelProductsGroup.sourcing = new SourcingDto(
				Object.assign(
					new Sourcing(),
					{
						outputEsoObjectId: level < 0 ? levelData.parentEsoObjectId : levelData.currentEsoObjectId,
						inputEsoObjectId: level < 0 ? levelData.currentEsoObjectId : levelData.parentEsoObjectId,
						inputQtyPerOutput: levelData.inputQtyPerOutput,
						esoObjectName: levelData.esoObjectName,
						ddMrpStockStatus: levelData.dDMrpStockStatus,
					}
				),
				Object.assign(
					new MappedSourcingDto(),
					levelData,
					{
						esoNetworkInfo: levelData.text
					}
				)
			);

			productsGroup.productsGroups.push(
				this.populateProductsGroupRecursively(
					data,
					levelProductsGroup,
					levelData.currentEsoObjectId,
					level + increment,
					increment
				)
			);
		}

		return productsGroup;
	}

	private _sourcingTreeList: DxTreeListComponent;
	public get sourcingTreeList(): DxTreeListComponent {
		return this._sourcingTreeList;
	}
	@ViewChild('sourcingTreeList', { static: true })
	public set sourcingTreeList(value: DxTreeListComponent) {
		this._sourcingTreeList = value;
	}

	private toCamelCase(value: string): string {
		if (!value) return value;

		return value.charAt(0).toLowerCase() + value.slice(1);
	}

	public async getSelectedProductData() {
		const $this = this;

		let inputLevels = +this.inputLevelsDropdownSelectedItemValue;
		let outputLevels = +this.outputLevelsDropdownSelectedItemValue;

		this._esoService.getEsoSourcingGraphData(
			{
				productId: this.selectedProduct.code,
				topRows: isNaN(this.topRows) ? null : this.topRows,
				upstreamLevel: isNaN(inputLevels) ? null : inputLevels,
				downStreamLevel: isNaN(outputLevels) ? null : outputLevels,
				orderByColumnName: this.orderByColumnName,
				orderByDirection: this.orderByDirection
			},
			{
				loadingIndicatorCounterGroupType: CounterGroups.CONTAINER_LOAD,
				loadingIndicatorCounterGroupId: "0"
			}
		).subscribe(
			{
				next: async (response) => {

					$this.sourcingData = new ProductsContainerDto();

					const zeroLevelData: SourcingGraphNode = response.find((item) => item.level === 0);

					$this.sourcingData.selectedProductSourcing = new SourcingDto(
						null,
						Object.assign(
							new MappedSourcingDto(),
							zeroLevelData,
							{
								esoNetworkInfo: zeroLevelData.text
							}
						)
					);

					$this.sourcingData.leftProductsGroup = this.populateProductsGroupRecursively(response, new ProductsGroupDto(), zeroLevelData.currentEsoObjectId, -1, -1);
					$this.sourcingData.rightProductsGroup = this.populateProductsGroupRecursively(response, new ProductsGroupDto(), zeroLevelData.currentEsoObjectId, 1, 1);

					console.error();

					$this._reload();

					// <Tree List>
					$this.sourcingTreeListData = response.filter((item) => item.level <= 0);
					// </Tree List>
				}
			}
		);

		this._settingsService.getSelections(
			SelectionSetId.EsoNetworkDeepDiveSourcingTreeListDataFields,
			{
				loadingIndicatorCounterGroupType: CounterGroups.CONTAINER_LOAD,
				loadingIndicatorCounterGroupId: "1"
			}
		).subscribe(
			{
				next: (selectionData: SelectionData) => {
					this.sourcingTreeListColumns = selectionData.selections.map(
						(selection: Selection) => {
							return {
								caption: selection.caption,
								columnName: this.toCamelCase(selection.selectionName)
							}
						}
					);
				}
			}
		);
	}

	scrollTop() {
		const el = document.getElementById("anchor");
		setTimeout(() => {
			if (el) {
				el.scrollIntoView({ behavior: "smooth", block: "center" });
			}
		}, 1);
	}

	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;
	}

	public selectProduct(productId: string) {

		const $this = this;

		// Create a new Temp Product until selected one is initialized, because many methods use this.selectedProduct to access code property.
		this.selectedProduct = Object.assign(new Product(), { code: productId });

		//TODO: get the id of route of this page from adding a functionality where route id is passed to the page metadata when the page is navigated to.
		// You can get this id from dynamic routes that are constructed.
		// ROUTE_METADATA should only be used for routes that are static and defined on client side.
		// The id metadata should be accessible on each page through some kind of special method which is agnostic to the page.
		// Let's say `this._navigationService.getRouteId(this)`, we already have data in web.Route table to identify the page.
		// Then `this._navigationService.getComponentRouteData(this._navigationService.getRouteId(this))` would be possible.
		let componentRouteData: ComponentRouteData = this._navigationService.getComponentRouteData(ROUTE_METADATA.NetworkDeepDive);

		const url = `${componentRouteData.routeFullPath}?${this._productIdQueryParamName}=${UtilsService.getURLHelper(this.selectedProduct.code)}`;
		this._location.replaceState(url);

		this.autocompleteCode = this.selectedProduct.code;

		this.getSelectedProductData();

		this.scrollTop();
	}

	// <Tree List>

	public getCompletionText(cellInfo) {
		return cellInfo.valueText + "%";
	}


	public onAutocompleteItemClick(event: any) {
		this.selectProduct(this.autocompleteCode);
	}

	public onInputLevelsDropdownClicked(event: any) {
		const selectedItem = event.itemData;

		this.inputLevelsDropdownSelectedItemValue = selectedItem;
		this.inputLevelsDropdownSelectedItem = `${NetworkDeepDiveComponent.INPUT_LEVELS_DROPDOWN_TEXT_PREFIX} ${this.inputLevelsDropdownSelectedItemValue}`;

		this.selectProduct(this.selectedProduct.code);
	}

	public onOutputLevelsDropdownClicked(event: any) {
		const selectedItem = event.itemData;

		this.outputLevelsDropdownSelectedItemValue = selectedItem;
		this.outputLevelsDropdownSelectedItem = `${NetworkDeepDiveComponent.OUTPUT_LEVELS_DROPDOWN_TEXT_PREFIX} ${this.outputLevelsDropdownSelectedItemValue}`;

		this.selectProduct(this.selectedProduct.code);
	}
}
